import React from "react";
import SvgClose from "../icons/SvgClose";

function FullModal({ isOpen, header, onClose, children, extra }) {
  return (
    <div
      className={`h-full fixed top-0 left-0 w-full z-[101] overflow-y-auto text-left ${
        isOpen ? "block" : "hidden"
      }`}
    >
      <div className="bg-pri-tint-3 pb-[50px] min-h-screen [@media(max-width:984px)]:bg-white">
        <div className="bg-white py-5 app-container [@media(max-width:984px)]:py-4 [@media(max-width:984px)]:border-b [@media(max-width:984px)]:border-neutral sticky top-0 left-0 z-[50]">
          <div className="flex justify-between items-center max-w-[1376px] mx-auto">
            <h5 className="font-semibold mb-0 text-dark [@media(max-width:984px)]:text-[20px] [@media(max-width:984px)]:leading-8">
              {header}
            </h5>
            {extra && <div>{extra}</div>}
            <button
              className="bg-pri-tint-3 pri flex justify-center items-center w-10 h-10 border border-pri rounded-md [@media(max-width:984px)]:w-6 [@media(max-width:984px)]:h-6"
              onClick={onClose}
            >
              <SvgClose className="w-3.5 h-3.5 [@media(max-width:984px)]:w-2 [@media(max-width:984px)]:h-2" />
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export default FullModal;
